export const BLOG_LABEL = 'Pickleball Hub';
export const MEME_SLUG = 'meme';
export const MEME_SUBCATEGORY_SLUG = 'memes';
